import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';
import { getSiteType } from '../../utils/getSiteType';
import { IProduct } from '../../types/analytics';
import { TRecommendation } from '../../types/recommendation';
import { mlSearchSession } from '../../utils/mlSearchSession';

interface ITrackRecommendationClickParams {
  offer: TRecommendation;
  position: number;
  deviceType: TDeviceType;
}

interface ITrackRecommendationsViewParams {
  deviceType: TDeviceType;
  products: IProduct[];
}

export function trackRecommendationsView({ deviceType, products }: ITrackRecommendationsViewParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'show_similar_offers',
    label: 'user-based',
    page: {
      pageType: 'Recommendations',
      siteType: getSiteType(deviceType),
    },
    products,
  });
}

export function trackRecommendationClick({ offer, deviceType, position }: ITrackRecommendationClickParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'click_similar_offers',
    label: 'user-based',
    page: {
      pageType: 'Recommendations',
      siteType: getSiteType(deviceType),
    },
    products: [
      {
        id: offer.offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
}

export function trackEntityTeaserShow(offerId: number, position: number, deviceType: TDeviceType) {
  ca('teaser', {
    page: {
      pageType: 'Recommendations',
      siteType: getSiteType(deviceType),
      extra: {
        mlSearchSessionGuid: mlSearchSession.getSessionGuid(),
      },
    },
    product: {
      id: offerId,
      name: 'show_card',
      extra: {
        offerType: 'offer',
      },
      position,
      screen: 'Recommendations',
      block: 'Recommendations',
    },
  });
}
